import { useStores } from '~store';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

export default function useEffectiveCompanyId() {
  const { userStore } = useStores();

  return getEffectiveUserCompanyId(userStore);
}
